import AnalysisFilterViewModel from "./AnalysisFilterViewModel";
import TimeSeriesAnalysisViewModel from "./TimeSeriesAnalysisViewModel";

export default class TimeSeriesAnalysisExportViewModel {
    filter: AnalysisFilterViewModel = new AnalysisFilterViewModel();
    tableRows: TimeSeriesAnalysisViewModel[] = [];
    chart: string = "";
    tripRateParameterTitle: string = "";
}
